import { updateTenantRole } from '@infuse/api/iam/tenant';
import { useGenericUpdateRole } from '@infuse/iam/role/mutations';

export const useUpdateTenantRole = () => {
  return useGenericUpdateRole({
    apiFn: updateTenantRole
  });
};
